"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasFavouriteUpdated;

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function hasFavouriteUpdated(latestFavouriteUpdate, prevFavouriteUpdate, posts) {
  if ((0, _lodash.default)(latestFavouriteUpdate, prevFavouriteUpdate)) {
    return false;
  }

  var inspirationId = latestFavouriteUpdate.inspirationId,
      isFavourited = latestFavouriteUpdate.isFavourited;
  var inspiration = posts.find(function (post) {
    return post.inspirationId === inspirationId;
  });

  if (!inspiration) {
    return false;
  }

  return inspiration.isFavourited !== isFavourited;
}